import React from "react"
import { concatStrings, uniqueId } from "../utilities"

const DfbInput = React.forwardRef((props, ref) => {
  const TagName = `${props.tagName.toLowerCase()}`
  const multilineClass =
    props.tagName.toLowerCase() === "textarea" ? "dfb-Input--multiline" : ""
  const required = props.required ? { required: true } : {}
  const disabled = props.disabled ? { disabled: true } : {}
  const disabledClass = props.disabled ? "is-disabled" : ""
  const noLabelClass = props.label ? "" : "dfb-input--plain"
  const errorClass = props.error ? "is-invalid" : ""
  const focusedClass = props.focused ? "is-focused" : ""
  const inputId = uniqueId(`${props.idPrefix}-`)
  const value = props.value != null ? { value: props.value } : {}
  const rows = props.rows ? { rows: props.rows } : {}
  return (
    <div
      className={concatStrings(
        "dfb-Input",
        multilineClass,
        noLabelClass,
        disabledClass,
        errorClass,
        focusedClass,
        props.add_class
      )}
    >
      <div className="dfb-Input-field">
        {props.label && props.label.length > 0 && (
          <label className="dfb-Input-label" htmlFor={inputId}>
            {props.label}
          </label>
        )}
        <TagName
          ref={ref}
          className="dfb-Input-input"
          type={props.type || "text"}
          name={props.name}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onBlur={props.onBlur}
          id={inputId}
          {...required}
          {...disabled}
          {...value}
          {...rows}
        ></TagName>
      </div>
      <p className="dfb-Paragraph dfb-Paragraph--small dfb-Input-errorMessage">
        {props.errorMessage}
      </p>
    </div>
  )
})
DfbInput.defaultProps = {
  tagName: "input",
  idPrefix: "input",
  required: false,
  disabled: false,
  error: false,
}
export default DfbInput
